module.exports = __webpack_public_path__ + "static/media/call.12da7270.svg";